




















import {Component, Vue} from "vue-property-decorator";
import AccountService from "@/components/domains/account/accountService";
import PasswordlessService from "@/components/domains/auth/passwordlessService";
import {emailFieldError} from "@/components/domains/auth/authPolicy";

@Component
export default class EnterpriseAccountRegisterForm extends Vue {
  name = "EnterpriseAccountRegisterForm"

  // Form
  agencyName = "";
  username = "";
  password = "";
  verifyPassword = "";
  // ログイン用のメールアドレス（マジックリンクが有効なときは必須）
  email = "";
  emailRequired = false;
  emailError = "";

  mounted(): void {
    PasswordlessService.loadPolicy({fresh: true}).then((p) => (this.emailRequired = p.magicLinkAvailable));
  }

  // 登録
  register() {
    this.emailError = emailFieldError(this.email, this.emailRequired);
    if (this.emailError) return;
    AccountService.registerEnterpriseAccount(this.agencyName, this.username, this.password, this.verifyPassword, this.email)
        .then((id) => {
          // TODO 完了音
          alert(id + ': 登録完了しました。');
        })
        .catch(error => {
          // TODO ビープ音
          alert(error.response.data.message);
        });
  }
}
